import { Expose } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString } from "class-validator";

export class OfficeProfile {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
}

export class OfficeProfileDetails {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  printCulture!: string;
  @Expose()
  @IsString()
  issuePlace!: string;
  @Expose()
  @IsOptional()
  @IsString()
  phoneNumber!: string | null;
  @Expose()
  @IsOptional()
  @IsString()
  emailAddress!: string | null;
  @Expose()
  @IsNumber()
  editTimeForUser!: number;
  @Expose()
  @IsNumber()
  editTimeForAdmin!: number;
  @Expose()
  @IsNumber()
  issueDateRangeForUser!: number;
  @Expose()
  @IsNumber()
  issueAndSaleDateDiffForUser!: number;
  @Expose()
  @IsBoolean()
  showBarCodeOnInvoice!: boolean;

  constructor(officeProfile?: OfficeProfileDetails) {
    if (officeProfile != undefined) {
      this.id = officeProfile.id;
      this.name = officeProfile.name;
      this.issuePlace = officeProfile.issuePlace;
      this.printCulture = officeProfile.printCulture;
      this.phoneNumber = officeProfile.phoneNumber;
      this.emailAddress = officeProfile.emailAddress;
      this.editTimeForUser = officeProfile.editTimeForUser;
      this.editTimeForAdmin = officeProfile.editTimeForAdmin;
      this.issueDateRangeForUser = officeProfile.issueDateRangeForUser;
      this.issueAndSaleDateDiffForUser = officeProfile.issueAndSaleDateDiffForUser;
      this.showBarCodeOnInvoice = officeProfile.showBarCodeOnInvoice;
    } else {
      this.id = 0;
      this.name = "";
      this.issuePlace = "";
      this.printCulture = "";
      this.phoneNumber = "";
      this.emailAddress = "";
      this.editTimeForUser = 1400;
      this.editTimeForAdmin = 1400;
      this.issueDateRangeForUser = 7;
      this.issueAndSaleDateDiffForUser = 7;
      this.showBarCodeOnInvoice = false;
    }
  }
}

export class OfficeProfileInfo {
  @Expose()
  @IsNumber()
  id!: number;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  officeId!: string;
  @Expose()
  @IsString()
  printCulture!: string;
  @Expose()
  @IsString()
  issuePlace!: string;
  @Expose()
  @IsOptional()
  @IsString()
  phoneNumber!: string | null;
  @Expose()
  @IsOptional()
  @IsString()
  emailAddress!: string | null;

  constructor(officeProfile?: OfficeProfileInfo) {
    this.id = officeProfile != undefined ? officeProfile.id : 0;
    this.officeId = officeProfile != undefined ? officeProfile.officeId : "";
    this.name = officeProfile != undefined ? officeProfile.name : "";
    this.issuePlace = officeProfile != undefined ? officeProfile.issuePlace : "";
    this.printCulture = officeProfile != undefined ? officeProfile.printCulture : "";
    this.phoneNumber = officeProfile != undefined ? officeProfile.phoneNumber : "";
    this.emailAddress = officeProfile != undefined ? officeProfile.emailAddress : "";
  }
}

export class OfficeDetails {
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  shortName!: string;
  @Expose()
  @IsString()
  tin!: string;
  @Expose()
  @IsString()
  country!: string;
  @Expose()
  @IsString()
  city!: string;
  @Expose()
  @IsString()
  streetAndNumber!: string;
  @Expose()
  @IsString()
  postalCode!: string;
  @Expose()
  @IsOptional()
  @IsString()
  emailAddress!: string;
  @Expose()
  @IsOptional()
  @IsString()
  phoneNumber!: string;

  constructor(officeProfile?: OfficeDetails) {
    if (officeProfile != undefined) {
      this.id = officeProfile.id;
      this.name = officeProfile.name;
      this.shortName = officeProfile.shortName;
      this.tin = officeProfile.tin;
      this.country = officeProfile.country;
      this.city = officeProfile.city;
      this.streetAndNumber = officeProfile.streetAndNumber;
      this.postalCode = officeProfile.postalCode;
      this.emailAddress = officeProfile.emailAddress;
      this.phoneNumber = officeProfile.phoneNumber;
    } else {
      this.id = "";
      this.name = "";
      this.shortName = "";
      this.tin = "";
      this.country = "";
      this.city = "";
      this.streetAndNumber = "";
      this.postalCode = "";
      this.emailAddress = "";
      this.phoneNumber = "";
    }
  }
}
